import MarketInfoCard from './MarketInfoCard';

import MarketIcon from '@/assets/icons/Market/MarketIcon.svg?react';
import { ROUTES } from '@/routes/paths';
import { useNavigate } from 'react-router-dom';
import type { MarketInfo } from './market-types';

interface MarketMenuBoardProps {
  marketInfoList: MarketInfo[];
}
const MarketMenuBoard = ({ marketInfoList }: MarketMenuBoardProps) => {
  const navigate = useNavigate();
  const handleRoute = (path: string) =>
    navigate({
      pathname: ROUTES.marketRegister + `/${path}`,
    });

  const handleAddMarketRequest = () => {
    navigate(ROUTES.reqAddMarket);
  };

  const marketPallang = marketInfoList.find((market) => market.MarketNameEnglish === 'pallang');
  const marketListExcludePallang = marketInfoList.filter(
    (market) => market.MarketNameEnglish !== 'pallang',
  );

  return (
    <div
      className="xl:grid-cols-5 2xl:grid-cols-6 grid w-full grid-cols-1
                  gap-[12px]
                  rounded-[16px]
                  bg-white
                  p-4
                  sm:grid-cols-2
                  md:grid-cols-3
                  lg:grid-cols-4
                  "
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
      }}
    >
      {marketPallang && (
        <MarketInfoCard
          className="col-span-full items-start bg-point-100 px-5"
          data={marketPallang}
          onClick={handleRoute}
          component={
            <div className="flex items-center gap-3">
              <img src={marketPallang.MarketIconUrl} alt="마켓 아이콘" className="h-10 w-10" />
              <div className="space-y-1.5">
                <div className="flex items-center gap-[4.5px]">
                  <span className="text-gr-700 Body4S14">팔랑</span>
                  <div className="rounded-sm bg-white px-1.5 py-0.5 text-point-500 Caption1M12">
                    PLUS
                  </div>
                </div>
                <div className="text-left text-gr-800 Caption1M12">
                  AI가 상세 페이지 제작을 뚝딱!
                  <br />
                  쇼핑몰 없이도 링크 하나로 판매를 시작할 수 있어요
                </div>
              </div>
            </div>
          }
        />
      )}
      {marketListExcludePallang.slice(0, marketInfoList.length - 2).map((item) => (
        <MarketInfoCard key={item.MarketSeqNo} data={{ ...item }} onClick={handleRoute} />
      ))}
      <button
        onClick={handleAddMarketRequest}
        className="relative flex h-[100px] min-w-[138px] flex-1 flex-col items-center  justify-center gap-[6px] rounded-sm bg-gr-100 py-[16px] transition-colors  duration-200 hover:bg-gr-200 "
      >
        <MarketIcon />
        <span className="text-gr-700 Body4S14">마켓 추가요청</span>
      </button>
    </div>
  );
};

export default MarketMenuBoard;
